// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__8T8dl","itemTitle":"ClientEmergencyInfo_itemTitle__2ivUL","itemText":"ClientEmergencyInfo_itemText__FUWKf"};